import {mapState} from "vuex";
import {getWxShare} from "../request/api";
import {wx_secendShare} from "../../util";
export default{
    data() {
        return {
            routeId:"",
            redirectPath:0
        }
    },
    computed:{
        ...mapState({
            modal: state=>state.common.modal,
            player: state=>state.common.player,
        }),
    },
    methods: {
        // 初始化微信分享
        globalInitWxShare(title, desc, cover){
            wx_secendShare(title, desc, cover)
            // getWxShare({url: location.href}).then(res=>{
            //     if(res.error_code == 0){
            //         wx_secendShare(title, desc, cover)
            //     }
            // })
        },
    // 下拉刷新事件
    pullDownListener(cb) {
      let el = document.getElementsByClassName("loading")[0];
      let height = window.innerHeight;

      window.addEventListener(
          "scroll",
          () => {
            let offset = window.pageYOffset;
              let data = {
                  windowHeight: height,
                  scrollTop: offset
              }
              cb(data)
          },
          false
      );
  },
        openDownModal(title,redirectPath,routeId,idname,){
            if(this.modal){
                this.modal.open(title)
            }
            if(redirectPath==18){
                this.modal.show=false
                ULink({
                    id: "usr1kva5smt2abij",
                    data:{redirectPath:18,cid:routeId},
                    selector: idname, //点击下载按钮的id
                    timeout: 200,
                    useOpenInBrowerTips: "default",
                    lazy: false,
                    auto: false,
                });
            }
        },
        
  },
}
